import { T } from '../strings'
import type { Theme } from '../theme'
import { factLabel, type GameState } from '../game/types'
import { accuracy, stars } from '../game/selectors'

interface Props {
  state: GameState
  theme: Theme
  onAgain: () => void
  onHome: () => void
}

export default function Result({ state, theme, onAgain, onHome }: Props) {
  const earned = stars(state)
  const tricky = state.tricky.slice(0, 4).map(factLabel)

  return (
    <div className="result">
      <div className="result__stars" aria-label={`${earned}/3`}>
        {[0, 1, 2].map((i) => (
          <div key={i} className="result__star" style={{ opacity: i < earned ? 1 : 0.2 }} aria-hidden>
            ⭐
          </div>
        ))}
      </div>

      <div className="result__title">{T.done}</div>

      <div className="result__line">
        <span style={{ color: theme.acc }}>+{state.sessionXp} XP</span>
        <span className="muted"> · </span>
        <span>
          {accuracy(state)}% {T.accuracy}
        </span>
      </div>

      {tricky.length > 0 && (
        <div className="result__tricky">
          {T.repeat} {tricky.join(', ')}
        </div>
      )}

      <div className="result__actions">
        <button type="button" className="btn-3d result__again" onClick={onAgain}>
          {T.again}
        </button>
        <button type="button" className="btn-ghost btn-scale result__home" onClick={onHome}>
          {T.toHome}
        </button>
      </div>
    </div>
  )
}
